import Scrollbars from 'react-custom-scrollbars';

import AnimationOpportunitiesList from 'modules/results/animation/AnimationOpportunities/AnimationOpportunitiesList';

import useTailwindBreakpoints from 'hooks/useTailwindBreakpoints';
import './AnimationOpportunities.css';

const AnimationOpportunities = () => {
  const { isSm } = useTailwindBreakpoints();

  if (isSm) {
    return null;
  }

  return (
    <div className="animation-opportunities p-m">
      <Scrollbars autoHide autoHeight autoHeightMax="calc(100vh - 310px)" className="scrollbar">
        <AnimationOpportunitiesList />
      </Scrollbars>
    </div>
  );
};

export default AnimationOpportunities;
